import React from 'react';

export const SearchGray500Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.74902 1.66699C12.6656 1.66699 15.8328 4.83348 15.833 8.75C15.833 10.4166 15.2496 12.0003 14.333 13.167L18.083 16.917C18.4162 17.2503 18.4163 17.7507 18.083 18.084C17.9163 18.2507 17.6657 18.334 17.499 18.334C17.3324 18.3339 17.0826 18.2504 16.916 18.084L13.166 14.334C11.916 15.2506 10.4156 15.834 8.74902 15.834C4.83251 15.8338 1.66602 12.6666 1.66602 8.75C1.66619 4.83359 4.83262 1.66717 8.74902 1.66699ZM8.74902 3.33398C5.74928 3.33416 3.33318 5.75026 3.33301 8.75C3.33301 11.7499 5.74917 14.1668 8.74902 14.167C10.249 14.167 11.583 13.584 12.583 12.584C13.583 11.584 14.166 10.25 14.166 8.75C14.1658 5.75015 11.7489 3.33398 8.74902 3.33398Z"
        fill="#555555"
      />
      <mask
        id="mask0_7985_57657"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="18"
        height="18"
      >
        <path
          d="M8.74902 1.66699C12.6656 1.66699 15.8328 4.83348 15.833 8.75C15.833 10.4166 15.2496 12.0003 14.333 13.167L18.083 16.917C18.4162 17.2503 18.4163 17.7507 18.083 18.084C17.9163 18.2507 17.6657 18.334 17.499 18.334C17.3324 18.3339 17.0826 18.2504 16.916 18.084L13.166 14.334C11.916 15.2506 10.4156 15.834 8.74902 15.834C4.83251 15.8338 1.66602 12.6666 1.66602 8.75C1.66619 4.83359 4.83262 1.66717 8.74902 1.66699ZM8.74902 3.33398C5.74928 3.33416 3.33318 5.75026 3.33301 8.75C3.33301 11.7499 5.74917 14.1668 8.74902 14.167C10.249 14.167 11.583 13.584 12.583 12.584C13.583 11.584 14.166 10.25 14.166 8.75C14.1658 5.75015 11.7489 3.33398 8.74902 3.33398Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_7985_57657)"></g>
    </svg>
  );
};
